import React from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, Search, ClipboardList, User, LogOut, Store, Menu, X,
} from 'lucide-react';
import { useStaffAuth } from '../../context/StaffAuthContext';

const NAV = [
  { icon: LayoutDashboard, label: 'Dashboard', path: '/staff/dashboard' },
  { icon: Search, label: 'Search Flights', path: '/staff/search' },
  { icon: ClipboardList, label: 'Bookings', path: '/staff/bookings' },
  { icon: User, label: 'Profile', path: '/staff/profile' },
];

export default function StaffLayout() {
  const { staff, logout } = useStaffAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/staff/login');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <aside className={`fixed inset-y-0 left-0 z-30 w-64 bg-[#1B375B] text-white transform transition-transform lg:translate-x-0 ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className="p-5 border-b border-white/10 flex items-center gap-3">
          <Store className="w-7 h-7 text-[#659A9B]" />
          <div>
            <p className="font-bold text-sm">ACF Counter</p>
            <p className="text-[10px] text-white/60">{staff?.branch_name || 'Staff Portal'}</p>
          </div>
          <button className="lg:hidden ml-auto" onClick={() => setMobileOpen(false)}><X className="w-5 h-5" /></button>
        </div>
        <nav className="p-3 space-y-1">
          {NAV.map(({ icon: Icon, label, path }) => {
            const active = location.pathname === path || location.pathname.startsWith(`${path}/`);
            return (
              <Link
                key={path}
                to={path}
                onClick={() => setMobileOpen(false)}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${active ? 'bg-white/15 text-white' : 'text-white/70 hover:bg-white/10 hover:text-white'}`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </Link>
            );
          })}
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-white/10">
          <button onClick={handleLogout} className="flex items-center gap-2 text-sm text-white/70 hover:text-white w-full px-3 py-2">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>

      <div className="flex-1 lg:ml-64">
        <header className="bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-3 lg:hidden">
          <button onClick={() => setMobileOpen(true)}><Menu className="w-6 h-6 text-[#1B375B]" /></button>
          <span className="font-bold text-[#1B375B]">Staff Portal</span>
        </header>
        <main className="min-h-screen">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
